module.exports = __webpack_public_path__ + "fonts/Typo_Round_Italic_Demo.f60908c6.otf";